import { SET_ACCOUNTING_CONNECTION, SET_AMAZON_BUSINESS_CONNECTION, SET_EMBURSE_CARDS_CONNECTIONS, SET_LOADING_EMBURSE_CARDS_CONNECTIONS, SET_SALESFORCE_CONNECTION, SET_SLACK_CONNECTION } from '@Actions/connectionsActions';
export const defaultState = {
    accountingConnection: null,
    salesforceConnection: null,
    slackConnection: null,
    amazonBusinessConnection: null,
    emburseCardsConnections: null,
    emburseCardsConnectionsIsLoading: false
};
export function connectionsReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_ACCOUNTING_CONNECTION:
            return Object.assign(Object.assign({}, state), { accountingConnection: action.payload });
        case SET_SALESFORCE_CONNECTION:
            return Object.assign(Object.assign({}, state), { salesforceConnection: action.payload });
        case SET_SLACK_CONNECTION:
            return Object.assign(Object.assign({}, state), { slackConnection: action.payload });
        case SET_AMAZON_BUSINESS_CONNECTION:
            return Object.assign(Object.assign({}, state), { amazonBusinessConnection: action.payload });
        case SET_EMBURSE_CARDS_CONNECTIONS:
            return Object.assign(Object.assign({}, state), { emburseCardsConnections: action.payload });
        case SET_LOADING_EMBURSE_CARDS_CONNECTIONS:
            return Object.assign(Object.assign({}, state), { emburseCardsConnectionsIsLoading: action.payload });
        default:
            return state;
    }
}
